export const EVENT_TRACKING = {
  NEW_FEATURE_ANNOUNCEMENT: {
    programFeatureReleaseModalViewed:
      'CRMW_program_feature_release_modal_viewed',
    programFeatureReleaseModalGetStartedClick:
      'CRMW_program_feature_release_modal_get_started_clicked',
  },
};
